import {gsap} from "gsap";
import {isMobile, isTablet} from "../components/helpers";

export function initSpnavigatorLanding() {
    if (!$('#spnavigator_landing').length) return;

    if (!isMobile() && !isTablet()) {
        const bgTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: $('.spnavigator-bg.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=100% bottom',
                scrub: 0.01,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.spnavigator-bg.first'), {
            xPercent: '-30',
            willChange: 'transform',
            duration: 0.5
        }).to($('.spnavigator-bg.first'), {
            xPercent: '30',
            willChange: 'transform',
            duration: 0.5
        })

        bgTimeline.timeScale(0.5)

        gsap.set($('.spnavigator-bg.second'), {
            xPercent: '-100'
        })

        const bgTimeline2 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.spnavigator-bg.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                //start: 'top top',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).to($('.spnavigator-bg.second'), {
            xPercent: '30',
            willChange: 'transform',
            duration: Math.max(0.25, $('.spnavigator-iphones-block.first').height() / 0.5),
        })

        const firstCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.spnavigator-iphones-block.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.spnavigator-iphones-block.first .center'), {
            translateY: '15%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.spnavigator-iphones-block.first .center'), {
            translateY: '-15%',
            willChange: 'auto'
        })

        const secondCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.spnavigator-iphones-block.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.spnavigator-iphones-block.second .center'), {
            translateY: '50%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.spnavigator-iphones-block.second .center'), {
            translateY: '-30%',
            willChange: 'auto'
        })

        gsap.set($('.spnavigator-iphones-block.first .right'), {
            translateY: '-10%'
        })

        gsap.set($('.spnavigator-iphones-block.second .left'), {
            translateY: '70%'
        })

        gsap.set($('.spnavigator-iphones-block.second .right'), {
            translateY: '20%'
        })

    }


}
